// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1amWi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ucJb"};